<template>
  <div>
    <div class="min-vh">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mb-0 header-main text-uppercase">SENTIMENT TRAINING</h1>
        </b-col>
      </CRow>
      <div class="bg-white-border mt-3">
        <b-row class="no-gutters">
          <b-col sm="6" xs="12">
            <div class="sentiment-container">
              <p>NEUTRAL</p>
              <div class="word-container" :class="{ spinner: isLoading }">
                <div v-if="isLoading">
                  <b-spinner></b-spinner>
                </div>
                <div v-else>
                  <div
                    class="word"
                    v-for="(item, index) in getNeutralLists"
                    :key="index"
                  >
                    <span class="mr-1 text-elipsis">
                      {{ item.sentimentText }}
                    </span>
                    <b-button
                      @click="onOpenDeleteModal(item)"
                      class="button-transparent"
                    >
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="input-container mt-3">
                <b-form-input
                  @keypress.enter="onCreateSentiment(1)"
                  v-model="textNetural"
                >
                </b-form-input>
                <b-button @click="onCreateSentiment(1)" class="button-color">
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col sm="6" xs="12" class="pr-sm-0 my-1">
            <div class="sentiment-container">
              <p>NEGATIVE</p>
              <div class="word-container" :class="{ spinner: isLoading }">
                <div v-if="isLoading">
                  <b-spinner></b-spinner>
                </div>
                <div v-else>
                  <div
                    class="word"
                    v-for="(item, index) in getNagativeLists"
                    :key="index"
                  >
                    <span class="mr-1 text-elipsis">
                      {{ item.sentimentText }}
                    </span>
                    <b-button
                      @click="onOpenDeleteModal(item)"
                      class="button-transparent"
                    >
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="input-container mt-3">
                <b-form-input
                  @keypress.enter="onCreateSentiment(0)"
                  v-model="textNegative"
                >
                </b-form-input>
                <b-button @click="onCreateSentiment(0)" class="button-color">
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <ModalAlertConfirm
        msg="ยืนยันการลบ ?"
        :text="modalMessage"
        btnConfirm="ลบ"
        colorBtnConfirm="danger"
        btnCancel="ยกเลิก"
        ref="ModalAlertConfirm"
        @confirm="onDelete"
      />
    </div>
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "SentimentTraining",
  components: {
    ModalAlertConfirm,
  },
  data() {
    return {
      modalMessage: "",
      textNetural: "",
      textNegative: "",
      items: [],
      isLoading: true,
      selectedId: null,
    };
  },
  mounted: async function() {
    await this.getSentimentList();
  },
  methods: {
    getSentimentList: async function() {
      this.isLoading = true;
      await this.axios.get(`${this.$baseUrl}/sentimentml/list/${this.$route.query.brandID}`).then((data) => {
        if (data.result === 1) {
          this.items = data.detail;
          this.isLoading = false;
        }
      });
    },
    onOpenDeleteModal: function(item) {
      this.selectedId = item.id;
      this.modalMessage = `คุณต้องการลบ "${item.sentimentText}" ใช่หรือไม่?`;
      this.$refs.ModalAlertConfirm.show();
    },
    onDelete: async function() {
      this.$refs.ModalAlertConfirm.hide();
      const deleteUrl = `${this.$baseUrl}/sentimentml/${this.selectedId}`;
      await this.axios.delete(deleteUrl).then((data) => {
        if (data.result == 1) {
          this.init();
          this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
        }
      });
    },
    onCreateSentiment: async function(type) {
      const NEUTRAL = 1;
      const NEGATIVE = 0;
      const filter = {
        Sentiment: type,
        SentimentText: type === NEUTRAL ? this.textNetural : this.textNegative,
        BrandId: parseInt(this.$route.query.brandID)
      };
      if(!filter.SentimentText){
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : "กรุณากรอกข้อมูล" }); 
        return
      }
      const url = `${this.$baseUrl}/sentimentml/Create`;
      await this.axios
        .post(url, filter)
        .then((data) => {
          if (data.result === 1) {
            this.init();
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
    },
    async init() {
      this.selectedId = null;
      this.textNetural = "",
      this.textNegative = "",
      await this.getSentimentList();
    },
  },
  computed: {
    getNeutralLists: function() {
      const neutralItems = this.items.filter((e) => {
        return e.sentimentType === "Neutral";
      });
      return neutralItems;
    },
    getNagativeLists: function() {
      const negativeItems = this.items.filter((e) => {
        return e.sentimentType === "Negative";
      });
      return negativeItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.sentiment-container {
  background-color: white;
  padding: 1rem;
  font-weight: bold;
  border-radius: 4px;
}

.word-container {
  border: 1px solid #cecdcd;
  border-radius: 4px;
  padding: 1rem;
  height: 600px;
  overflow-y: scroll;
}

.input-container {
  display: flex;
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 4px;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.word {
  border: 0px solid #cecdcd;
  border-radius: 24px;
  padding: 0.5rem 0.75rem;
  background-color: #f0eff9;
  display: inline-flex;
  margin: 0.5rem;
  justify-content: space-between;
  align-items: flex-start;
}

.text-elipsis {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.button-transparent {
  background-color: transparent;
  border: 0;
  padding: 0 !important;
}

.button-color {
  background-color: #8f20c6;
  color: white;
  padding: 6px 12px;
}

::-webkit-scrollbar-track {
  background-color: #bebebe;
}

::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: #000000;
  border: 2px solid #8b8b8b;
}
</style>
